module.exports = __webpack_public_path__ + "static/venice20893-f6094b289dcd97824b607d8bf32a8cfc.png";